export default __webpack_public_path__ + "static/media/submissionIcon.21aa31f4.svg";